export const CommonErrorCodes = {
  ERR_VALUE_NOT_VALID_EMAIL: 'ERR_VALUE_NOT_VALID_EMAIL',
  ERR_NOT_ALLOWED_GROUPS: 'ERR_NOT_ALLOWED_GROUPS',
  ERR_VALUE_SHOULD_NOT_BE_BLANK: 'ERR_VALUE_SHOULD_NOT_BE_BLANK',
  ERR_UNIQUE: 'ERR_UNIQUE',
  ERR_UNIQUE_CODE: 'ERR_UNIQUE_CODE',
  ERR_DUPLICATE_VALUES: 'ERR_DUPLICATE_VALUES',
  ERR_UNIQUE_EMAIL_ADDRESS: 'ERR_UNIQUE_EMAIL_ADDRESS',
  ERR_VALUE_SHOULD_BE_POSITIVE: 'ERR_VALUE_SHOULD_BE_POSITIVE',
  ERR_VALIDATION: 'ERR_VALIDATION',
  ERR_UNIQUE_USER: 'ERR_UNIQUE_USER',
  ERR_NO_ENTITIES_BOUND: 'ERR_NO_ENTITIES_BOUND',
  ERR_CUSTOMER_OUT_OF_SCOPE: 'ERR_CUSTOMER_OUT_OF_SCOPE',
  ERR_UNIQUE_NAME: 'ERR_UNIQUE_NAME',
  ERR_TOO_MANY_SUPPLIER_TEMPLATE_MATCHES:
    'ERR_TOO_MANY_SUPPLIER_TEMPLATE_MATCHES',
  ERR_TOO_MANY_REDISTRIBUTION_SUPPLIER_TEMPLATE_MATCHES:
    'ERR_TOO_MANY_REDISTRIBUTION_SUPPLIER_TEMPLATE_MATCHES',
  ERR_TOO_MANY_SETTING_TEMPLATE_MATCHES:
    'ERR_TOO_MANY_SETTING_TEMPLATE_MATCHES',
  ERR_TOO_MANY_S2S_FLOW_TEMPLATE_MATCHES:
    'ERR_TOO_MANY_S2S_FLOW_TEMPLATE_MATCHES',
  ERR_DUPLICATE_S2S_FLOW: 'ERR_DUPLICATE_S2S_FLOW',
  ERR_COUNTRY_IN_USE_BY_CUSTOMERS: 'ERR_COUNTRY_IN_USE_BY_CUSTOMERS',
  ERR_LANGUAGE_NOT_FOUND: 'ERR_LANGUAGE_NOT_FOUND',
  ERR_LANGUAGE_IN_USE_BY_USERS: 'ERR_LANGUAGE_IN_USE_BY_USERS',
  ERR_LANGUAGE_IN_USE_BY_CUSTOMERS: 'ERR_LANGUAGE_IN_USE_BY_CUSTOMERS',
  ERR_TOO_MANY_BRAND_TEMPLATE_MATCHES: 'ERR_TOO_MANY_BRAND_TEMPLATE_MATCHES',
  ERR_CRITERION_IN_USE: 'ERR_CRITERION_IN_USE',
  ERR_CRITERIA_VALUES_IN_USE: 'ERR_CRITERIA_VALUES_IN_USE',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  NOT_FOUND: 'NOT_FOUND',
  ERR_FEATURE_GROUPS_USAGE: 'ERR_FEATURE_GROUPS_USAGE',
  ERR_DESTOCKING_REQUIRES_REDISTRIBUTION:
    'ERR_DESTOCKING_REQUIRES_REDISTRIBUTION',
  ERR_DESTOCKING_MODULE_DISABLED: 'ERR_DESTOCKING_MODULE_DISABLED',
  ERR_INTERNAL_STOCK_LOCKED_BY_ACTIVE_DESTOCKING:
    'ERR_INTERNAL_STOCK_LOCKED_BY_ACTIVE_DESTOCKING',
  ERR_RESOURCE_VALIDATION: 'ERR_RESOURCE_VALIDATION',
  ERR_VALUE_SHOULD_BE_FALSE: 'ERR_VALUE_SHOULD_BE_FALSE',
  ERR_VALUE_SHOULD_BE_TRUE: 'ERR_VALUE_SHOULD_BE_TRUE',
  ERR_ORDER_VALIDATION_REQUIRES_AUTO_VALIDATION:
    'ERR_ORDER_VALIDATION_REQUIRES_AUTO_VALIDATION',
  ERR_DMS_SENDING_REQUIRES_DMS_ENABLED: 'ERR_DMS_SENDING_REQUIRES_DMS_ENABLED',
  ERR_DMS_SENDING_MODES_EXCLUSIVE: 'ERR_DMS_SENDING_MODES_EXCLUSIVE',
  ERR_STORE_DELIVERY_REQUIRES_DIRECT_DELIVERY:
    'ERR_STORE_DELIVERY_REQUIRES_DIRECT_DELIVERY',
  ERR_INTERMEDIATE_STATUS_NOT_ALLOWED: 'ERR_INTERMEDIATE_STATUS_NOT_ALLOWED',
  ERR_VALUE_SHOULD_BE_OF_TYPE: 'ERR_VALUE_SHOULD_BE_OF_TYPE',
  ERR_VALUE_SHOULD_BE_BLANK: 'ERR_VALUE_SHOULD_BE_BLANK',
  ERR_VALUE_SHOULD_BE_VALID_CHOICE: 'ERR_VALUE_SHOULD_BE_VALID_CHOICE',
  ERR_MUST_SELECT_AT_LEAST_N_CHOICES: 'ERR_MUST_SELECT_AT_LEAST_N_CHOICES',
  ERR_MUST_SELECT_AT_MOST_N_CHOICES: 'ERR_MUST_SELECT_AT_MOST_N_CHOICES',
  ERR_ONE_OR_MORE_INVALID_VALUES: 'ERR_ONE_OR_MORE_INVALID_VALUES',
  ERR_FILE_NOT_FOUND: 'ERR_FILE_NOT_FOUND',
  ERR_FILE_NOT_READABLE: 'ERR_FILE_NOT_READABLE',
  ERR_FILE_TOO_LARGE: 'ERR_FILE_TOO_LARGE',
  ERR_MIME_TYPE_INVALID: 'ERR_MIME_TYPE_INVALID',
  ERR_VALUE_SHOULD_BE_LESS_THAN_OR_EQUAL_TO:
    'ERR_VALUE_SHOULD_BE_LESS_THAN_OR_EQUAL_TO',
  ERR_VALUE_TOO_LONG: 'ERR_VALUE_TOO_LONG',
  ERR_VALUE_SHOULD_BE_GREATER_THAN_OR_EQUAL_TO:
    'ERR_VALUE_SHOULD_BE_GREATER_THAN_OR_EQUAL_TO',
  ERR_VALUE_TOO_SHORT: 'ERR_VALUE_TOO_SHORT',
  ERR_VALUE_SHOULD_NOT_BE_NULL: 'ERR_VALUE_SHOULD_NOT_BE_NULL',
  ERR_VALUE_SHOULD_BE_NULL: 'ERR_VALUE_SHOULD_BE_NULL',
  ERR_VALUE_NOT_VALID: 'ERR_VALUE_NOT_VALID',
  ERR_TWO_VALUES_SHOULD_BE_EQUAL: 'ERR_TWO_VALUES_SHOULD_BE_EQUAL',
  ERR_FILE_COULD_NOT_BE_UPLOADED: 'ERR_FILE_COULD_NOT_BE_UPLOADED',
  ERR_VALUE_SHOULD_BE_A_VALID_NUMBER: 'ERR_VALUE_SHOULD_BE_A_VALID_NUMBER',
  ERR_RESOURCE_MUST_BE_UNIQUE: 'ERR_RESOURCE_MUST_BE_UNIQUE',
  ERR_IMAGE_SIZE_COULD_NOT_BE_DETECTED: 'ERR_IMAGE_SIZE_COULD_NOT_BE_DETECTED',
  ERR_IMAGE_WIDTH_TOO_BIG: 'ERR_IMAGE_WIDTH_TOO_BIG',
  ERR_IMAGE_WIDTH_TOO_SMALL: 'ERR_IMAGE_WIDTH_TOO_SMALL',
  ERR_IMAGE_HEIGHT_TOO_BIG: 'ERR_IMAGE_HEIGHT_TOO_BIG',
  ERR_IMAGE_HEIGHT_TOO_SMALL: 'ERR_IMAGE_HEIGHT_TOO_SMALL',
  ERR_VALUE_SHOULD_HAVE_EXACTLY_N_CHARACTERS:
    'ERR_VALUE_SHOULD_HAVE_EXACTLY_N_CHARACTERS',
  ERR_FILE_WAS_ONLY_PARTIALLY_UPLOADED: 'ERR_FILE_WAS_ONLY_PARTIALLY_UPLOADED',
  ERR_NO_FILE_WAS_UPLOADED: 'ERR_NO_FILE_WAS_UPLOADED',
  ERR_COLLECTION_SHOULD_CONTAIN_N_OR_MORE_ELEMENTS:
    'ERR_COLLECTION_SHOULD_CONTAIN_N_OR_MORE_ELEMENTS',
  ERR_COLLECTION_SHOULD_CONTAIN_N_OR_LESS_ELEMENTS:
    'ERR_COLLECTION_SHOULD_CONTAIN_N_OR_LESS_ELEMENTS',
  ERR_COLLECTION_SHOULD_CONTAIN_EXACTLY_N_ELEMENTS:
    'ERR_COLLECTION_SHOULD_CONTAIN_EXACTLY_N_ELEMENTS',
  ERR_VALUE_SHOULD_BE_EQUAL_TO: 'ERR_VALUE_SHOULD_BE_EQUAL_TO',
  ERR_VALUE_SHOULD_BE_GREATER_THAN: 'ERR_VALUE_SHOULD_BE_GREATER_THAN',
  ERR_VALUE_SHOULD_BE_IDENTICAL_TO: 'ERR_VALUE_SHOULD_BE_IDENTICAL_TO',
  ERR_VALUE_SHOULD_BE_LESS_THAN: 'ERR_VALUE_SHOULD_BE_LESS_THAN',
  ERR_VALUE_SHOULD_NOT_BE_EQUAL_TO: 'ERR_VALUE_SHOULD_NOT_BE_EQUAL_TO',
  ERR_VALUE_SHOULD_NOT_BE_IDENTICAL_TO: 'ERR_VALUE_SHOULD_NOT_BE_IDENTICAL_TO',
  ERR_IMAGE_RATIO_TOO_BIG: 'ERR_IMAGE_RATIO_TOO_BIG',
  ERR_IMAGE_RATIO_TOO_SMALL: 'ERR_IMAGE_RATIO_TOO_SMALL',
  ERR_IMAGE_IS_SQUARE: 'ERR_IMAGE_IS_SQUARE',
  ERR_IMAGE_IS_LANDSCAPE: 'ERR_IMAGE_IS_LANDSCAPE',
  ERR_IMAGE_IS_PORTRAIT: 'ERR_IMAGE_IS_PORTRAIT',
  ERR_EMPTY_FILE_NOT_ALLOWED: 'ERR_EMPTY_FILE_NOT_ALLOWED',
  ERR_VALUE_SHOULD_BE_A_MULTIPLE_OF: 'ERR_VALUE_SHOULD_BE_A_MULTIPLE_OF',
  ERR_COLLECTION_SHOULD_CONTAIN_ONLY_UNIQUE_ELEMENTS:
    'ERR_COLLECTION_SHOULD_CONTAIN_ONLY_UNIQUE_ELEMENTS',
  ERR_VALUE_SHOULD_BE_EITHER_POSITIVE_OR_ZERO:
    'ERR_VALUE_SHOULD_BE_EITHER_POSITIVE_OR_ZERO',
  ERR_VALUE_SHOULD_BE_NEGATIVE: 'ERR_VALUE_SHOULD_BE_NEGATIVE',
  ERR_VALUE_SHOULD_BE_EITHER_NEGATIVE_OR_ZERO:
    'ERR_VALUE_SHOULD_BE_EITHER_NEGATIVE_OR_ZERO',
  ERR_VALUE_SHOULD_BE_BETWEEN: 'ERR_VALUE_SHOULD_BE_BETWEEN',
  ERR_CALL_CENTER_CUSTOMER_N1_ONLY: 'ERR_CALL_CENTER_CUSTOMER_N1_ONLY',
  ERR_JOB_PENDING: 'ERR_JOB_PENDING',
  ERR_CONTAINER_REFERENCE_REQUIRED_AFTER_ACCEPT:
    'ERR_CONTAINER_REFERENCE_REQUIRED_AFTER_ACCEPT',
  ERR_INVALID_CUSTOMER: 'ERR_INVALID_CUSTOMER',
  // User import validation error codes
  ERR_IMPORT_USER_INVALID_EMAIL: 'ERR_IMPORT_USER_INVALID_EMAIL',
  ERR_IMPORT_USER_INVALID_CUSTOMER_CODES:
    'ERR_IMPORT_USER_INVALID_CUSTOMER_CODES',
  ERR_IMPORT_USER_INVALID_GROUPS: 'ERR_IMPORT_USER_INVALID_GROUPS',
  ERR_IMPORT_USER_INVALID_FIRST_NAME: 'ERR_IMPORT_USER_INVALID_FIRST_NAME',
  ERR_IMPORT_USER_INVALID_LAST_NAME: 'ERR_IMPORT_USER_INVALID_LAST_NAME',
  ERR_IMPORT_USER_INVALID_INTERNAL_CODE:
    'ERR_IMPORT_USER_INVALID_INTERNAL_CODE',
  ERR_IMPORT_USER_INVALID_LOCALE: 'ERR_IMPORT_USER_INVALID_LOCALE',
  ERR_IMPORT_USER_INVALID_ACTIVE: 'ERR_IMPORT_USER_INVALID_ACTIVE',
  ERR_INVALID_HEADER_LENGTH: 'ERR_INVALID_HEADER_LENGTH',
  ERR_IMPORT_CUSTOMER_DIRECT_DELIVERY_REQUIRED:
    'ERR_IMPORT_CUSTOMER_DIRECT_DELIVERY_REQUIRED',
  ERR_IMPORT_CUSTOMER_INVALID_LOCALE: 'ERR_IMPORT_CUSTOMER_INVALID_LOCALE',
  ERR_IMPORT_CUSTOMER_INVALID_USER: 'ERR_IMPORT_CUSTOMER_INVALID_USER',
  ERR_IMPORT_CUSTOMER_NAME_REQUIRED: 'ERR_IMPORT_CUSTOMER_NAME_REQUIRED',
  ERR_IMPORT_CUSTOMER_DELIVERY_ADDRESS_REQUIRED:
    'ERR_IMPORT_CUSTOMER_DELIVERY_ADDRESS_REQUIRED',
  ERR_IMPORT_CUSTOMER_ZIP_CODE_REQUIRED:
    'ERR_IMPORT_CUSTOMER_ZIP_CODE_REQUIRED',
  ERR_IMPORT_CUSTOMER_CITY_REQUIRED: 'ERR_IMPORT_CUSTOMER_CITY_REQUIRED',
  ERR_IMPORT_CUSTOMER_INVALID_ACTIVE: 'ERR_IMPORT_CUSTOMER_INVALID_ACTIVE',
  ERR_IMPORT_CUSTOMER_CRITERIA_REQUIRED:
    'ERR_IMPORT_CUSTOMER_CRITERIA_REQUIRED',
  ERR_IMPORT_CUSTOMER_BILLING_CODE_REQUIRED:
    'ERR_IMPORT_CUSTOMER_BILLING_CODE_REQUIRED',
  ERR_CUSTOMER_CODE_ALREADY_USED: 'ERR_CUSTOMER_CODE_ALREADY_USED',
  ERR_CUSTOMER_NOT_ALLOWED: 'ERR_CUSTOMER_NOT_ALLOWED',
  ERR_INVALID_COUNTRY: 'ERR_INVALID_COUNTRY',
  ERR_INVALID_ECOTAX_ZONE: 'ERR_INVALID_ECOTAX_ZONE',
  ERR_INVALID_VAT_ZONE: 'ERR_INVALID_VAT_ZONE',
  ERR_INVALID_CUSTOMER_GROUP: 'ERR_INVALID_CUSTOMER_GROUP',
  ERR_INVALID_CRITERIA: 'ERR_INVALID_CRITERIA',
  ERR_INVALID_DIAGNOSIS_PROVIDER: 'ERR_INVALID_DIAGNOSIS_PROVIDER',
  ERR_INVALID_QUOTE_TARGET: 'ERR_INVALID_QUOTE_TARGET',
  ERR_INVALID_MANAGER: 'ERR_INVALID_MANAGER',
  ERR_MANAGER_NOT_ALLOWED: 'ERR_MANAGER_NOT_ALLOWED',
  ERR_INCONSISTENT_CURRENCY: 'ERR_INCONSISTENT_CURRENCY',
} as const;

export const PurchaseErrorCodes = {
  ERR_TECHNICAL_ISSUE: 'ERR_TECHNICAL_ISSUE',
  ERR_QUANTITY_0: 'ERR_QUANTITY_0',
  ERR_QUANTITY_CHANGED: 'ERR_QUANTITY_CHANGED',
  ERR_DELIVERY_DATE_CHANGED: 'ERR_DELIVERY_DATE_CHANGED',
  ERR_BACKORDER_CHANGED: 'ERR_BACKORDER_CHANGED',
  ERR_PRICE_CHANGED: 'ERR_PRICE_CHANGED',
  ERR_OFFER_REPLACED: 'ERR_OFFER_REPLACED',
  // OTHER CASE
  ERR_OBSOLETE_CART: 'ERR_OBSOLETE_CART',
  ERR_CART_EMPTY_QUANTITY: 'ERR_CART_EMPTY_QUANTITY',
  ERR_CUSTOMER_BRAND_NOT_FOUND: 'ERR_CUSTOMER_BRAND_NOT_FOUND',
  ERR_CUSTOMER_CONFIGURATION_NOT_FOUND: 'ERR_CUSTOMER_CONFIGURATION_NOT_FOUND',
  ERR_TENANT_SETTINGS_NOT_FOUND: 'ERR_TENANT_SETTINGS_NOT_FOUND',
  ERR_MAX_SEARCH_RESULT_EXCEEDED: 'ERR_MAX_SEARCH_RESULT_EXCEEDED',
  ERR_VALIDATION: 'ERR_VALIDATION',
  ERR_INVALID_CART: 'ERR_INVALID_CART',
  ERR_ACCEPT_ORDER_DATA_CHANGED: 'ERR_ACCEPT_ORDER_DATA_CHANGED',
  ERR_ACCEPT_EMPTY_QUANTITY: 'ERR_ACCEPT_EMPTY_QUANTITY',
  ERR_CART_MODIFIED_BY_ANOTHER_PROCESS: 'ERR_CART_MODIFIED_BY_ANOTHER_PROCESS',
  // Stock Price Error
  ERR_GET_STOCK_PRICE_TIMEOUT: 'ERR_GET_STOCK_PRICE_TIMEOUT',
  ERR_GET_STOCK_PRICE_SERVER_ERROR: 'ERR_GET_STOCK_PRICE_SERVER_ERROR',
  // Inquiry Manu Error
  ERR_INQUIRY_MANUFACTURER_TIMEOUT: 'ERR_INQUIRY_MANUFACTURER_TIMEOUT',
  ERR_INQUIRY_MANUFACTURER_SERVER_ERROR:
    'ERR_INQUIRY_MANUFACTURER_SERVER_ERROR',

  // container pricing policy
  CONTAINER_PRICING_POLICY_EMPTY_EAN: 'CONTAINER_PRICING_POLICY_EMPTY_EAN',
  CONTAINER_PRICING_POLICY_EXISTING_EAN:
    'CONTAINER_PRICING_POLICY_EXISTING_EAN',
  CONTAINER_PRICING_POLICY_INVALID_PRICE:
    'CONTAINER_PRICING_POLICY_INVALID_PRICE',
  CONTAINER_PRICING_POLICY_EAN_NOT_FOUND:
    'CONTAINER_PRICING_POLICY_EAN_NOT_FOUND',
  CONTAINER_PRICING_POLICY_TOO_FEW_COLUMNS:
    'CONTAINER_PRICING_POLICY_TOO_FEW_COLUMNS',
  CONTAINER_PRICING_POLICY_EMPTY_POLICY_NAME:
    'CONTAINER_PRICING_POLICY_EMPTY_POLICY_NAME',
  CONTAINER_PRICING_POLICY_INVALID_CURRENCY:
    'CONTAINER_PRICING_POLICY_INVALID_CURRENCY',
  CONTAINER_PRICING_POLICY_INVALID_INCOTERM:
    'CONTAINER_PRICING_POLICY_INVALID_INCOTERM',
  CONTAINER_PRICING_POLICY_EXISTING_POLICY_NAME:
    'CONTAINER_PRICING_POLICY_EXISTING_POLICY_NAME',
  CONTAINER_PRICING_POLICY_OVERLAP: 'CONTAINER_PRICING_POLICY_OVERLAP',
  CONTAINER_PRICING_POLICY_FILE_PARSE_ERROR:
    'CONTAINER_PRICING_POLICY_FILE_PARSE_ERROR',
  CONTAINER_PRICING_POLICY_FILE_UPLOAD_ERROR:
    'CONTAINER_PRICING_POLICY_FILE_UPLOAD_ERROR',
  ERR_CONTAINER_OFFER_PRICING_POLICIES_NOT_FOUND:
    'ERR_CONTAINER_OFFER_PRICING_POLICIES_NOT_FOUND',
  ERR_CONTAINER_OFFER_INVALID_FILL_RATE:
    'ERR_CONTAINER_OFFER_INVALID_FILL_RATE',
  // container EAN errors for copy/paste
  ERR_CONTAINER_INVALID_REQUEST_ENTRIES:
    'ERR_CONTAINER_INVALID_REQUEST_ENTRIES',
  ERR_CONTAINER_EAN_NOT_IN_CATALOG: 'ERR_CONTAINER_EAN_NOT_IN_CATALOG',
  ERR_CONTAINER_EAN_NO_PRICING_POLICY: 'ERR_CONTAINER_EAN_NO_PRICING_POLICY',
  ERR_CONTAINER_EAN_REDUNDANT: 'ERR_CONTAINER_EAN_REDUNDANT',
  ERR_CONTAINER_IMPORT_INVALID_QUANTITY:
    'ERR_CONTAINER_IMPORT_INVALID_QUANTITY',
  ERR_CONTAINER_IMPORT_EMPTY_EAN: 'ERR_CONTAINER_IMPORT_EMPTY_EAN',
  ERR_CONTAINER_IMPORT_EMPTY_QUANTITY: 'ERR_CONTAINER_IMPORT_EMPTY_QUANTITY',
  ERR_CONTAINER_IMPORT_EMPTY_NUMBER: 'ERR_CONTAINER_IMPORT_EMPTY_NUMBER',
  ERR_CONTAINER_IMPORT_INVALID_CONTAINER_ID:
    'ERR_CONTAINER_IMPORT_INVALID_CONTAINER_ID',
  ERR_CONTAINER_TRANSPORT_ITEM_TRANSITION_NOT_ALLOWED:
    'ERR_CONTAINER_TRANSPORT_ITEM_TRANSITION_NOT_ALLOWED',
  ERR_CONTAINER_TRANSPORT_ITEM_UPDATE_NOT_ALLOWED:
    'ERR_CONTAINER_TRANSPORT_ITEM_UPDATE_NOT_ALLOWED',
  CONTAINER_PRICING_POLICY_ACTIVE_START_DATE_LOCKED:
    'CONTAINER_PRICING_POLICY_ACTIVE_START_DATE_LOCKED',
  CONTAINER_PRICING_POLICY_START_DATE_IN_PAST:
    'CONTAINER_PRICING_POLICY_START_DATE_IN_PAST',
  CONTAINER_PRICING_POLICY_END_DATE_IN_PAST:
    'CONTAINER_PRICING_POLICY_END_DATE_IN_PAST',
  CONTAINER_PRICING_POLICY_END_DATE_BEFORE_START:
    'CONTAINER_PRICING_POLICY_END_DATE_BEFORE_START',
  CONTAINER_PRICING_POLICY_END_DATE_BEFORE_OR_SAME_AS_START_DATE:
    'CONTAINER_PRICING_POLICY_END_DATE_BEFORE_OR_SAME_AS_START_DATE',
  CONTAINER_PRICING_POLICY_ACTIVE_START_DATE_CANNOT_BE_CHANGED:
    'CONTAINER_PRICING_POLICY_ACTIVE_START_DATE_CANNOT_BE_CHANGED',
  DESTOCKING_PRICING_POLICY_FILE_VALIDATION_ERROR:
    'DESTOCKING_PRICING_POLICY_FILE_VALIDATION_ERROR',
  DESTOCKING_PRICING_POLICY_ROW_COUNT_ERROR:
    'DESTOCKING_PRICING_POLICY_ROW_COUNT_ERROR',
  DESTOCKING_PRICING_POLICY_MISSING_FIELD_ERROR:
    'DESTOCKING_PRICING_POLICY_MISSING_FIELD_ERROR',
  DESTOCKING_PRICING_POLICY_INVALID_PRICE_ERROR:
    'DESTOCKING_PRICING_POLICY_INVALID_PRICE_ERROR',
  DESTOCKING_PRICING_POLICY_INVALID_IDENTIFIER_ERROR:
    'DESTOCKING_PRICING_POLICY_INVALID_IDENTIFIER_ERROR',
  DESTOCKING_PRICING_POLICY_REPEATING_IDENTIFIER_ERROR:
    'DESTOCKING_PRICING_POLICY_REPEATING_IDENTIFIER_ERROR',
  DESTOCKING_PRICING_POLICY_OVERLAP_ERROR:
    'DESTOCKING_PRICING_POLICY_OVERLAP_ERROR',
  DESTOCKING_PRICING_POLICY_NO_INTERNAL_STOCK:
    'DESTOCKING_PRICING_POLICY_NO_INTERNAL_STOCK',
} as const;

export const QuoteErrorCodes = {
  ERR_ACTIVE_PRICING_POLICY_EXISTS: 'ERR_ACTIVE_PRICING_POLICY_EXISTS',
} as const;

export const RedistributionErrorCodes = {
  ERR_ACTIVE_PRICING_POLICY_EXISTS: 'ERR_ACTIVE_PRICING_POLICY_EXISTS',
} as const;

export const AnonymousErrorCodes = {
  ERR_INVALID_PASSWORD: 'ERR_INVALID_PASSWORD',
  ERR_REGISTRATION_CUSTOMER_NOT_FOUND: 'ERR_REGISTRATION_CUSTOMER_NOT_FOUND',
  ERR_REGISTRATION_MANAGER_EXISTS: 'ERR_REGISTRATION_MANAGER_EXISTS',
  ERR_USER_NOT_FOUND: 'ERR_USER_NOT_FOUND',
  ERR_USER_ALREADY_ONBOARDED: 'ERR_USER_ALREADY_ONBOARDED',
  ERR_USER_INVALID_TOKEN: 'ERR_USER_INVALID_TOKEN',
  ERR_UNIQUE_USER: 'ERR_UNIQUE_USER',
} as const;
